import { render, staticRenderFns } from "./GoodAdd.vue?vue&type=template&id=13749b58&scoped=true&"
import script from "./GoodAdd.vue?vue&type=script&lang=ts&"
export * from "./GoodAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13749b58",
  null
  
)

export default component.exports